import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  createRef,
  useMemo,
} from "react";
import {
  Modal,
  makeStyles,
  Fade,
  Backdrop,
  Button,
  Box,
  LinearProgress,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  DialogActions,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  withStyles,
  Divider,
  Slide,
  Grid,
} from "@material-ui/core";

import { Formik, Form, Field } from "formik";
import CustomSelectInput from "./../../inputs/CustomSelectInput";

import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import SearchIcon from "@material-ui/icons/Search";
import MuiDialogTitle from "@material-ui/core/DialogTitle";

import MaterialTable from "material-table";
import { useDispatch, useSelector } from "react-redux";
import { getDepts } from "./../../../redux/actions/department.action";
import { getProduct } from "./../../../redux/actions/product.action";
import { getBrands } from "./../../../redux/actions/brand.action";
import { getAllPermissions } from "../../../redux/actions/backOffice.action";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 600,
    padding: 1,
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
    lineHeight: "5ch",
    alignContent: "center",
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    overflowX: "auto",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PermissionModalComponent({
  open,
  handleClose,
  handleAdd,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { permissions } = useSelector((state) => state.backOfficeReducer);

  const [rowSelect, setRowSelect] = useState({});

  useEffect(() => {
    if (open) {
      dispatch(getAllPermissions());
    }
    return () => {};
  }, [open]);

  return (
    <div className={classes.modal}>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        TransitionComponent={Transition}
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Choose Permission
        </DialogTitle>
        <DialogContent dividers>
          <Box display="flex" component="div" flexDirection="column">
            <Box>
              <MaterialTable
                title
                columns={[
                  {
                    field: "NAME",
                    title: "Name",
                  },
                  {
                    field: "VALUE_NUMBER",
                    title: "Value Number",
                  },
                  {
                    field: "VALUE_TXT",
                    title: "Value Text",
                  },
                  {
                    field: "CREATED_AT",
                    title: "Created At",
                    type: "datetime",
                    defaultSort: "desc",
                  },
                ]}
                data={permissions.data}
                isLoading={permissions.isLoading}
                options={{
                  selection: true,
                  pageSize: 10,
                  detailPanelType: "single",
                }}
                onSelectionChange={(rows) => {
                  // alert(JSON.stringify(rows));
                  setRowSelect({ ...rowSelect, rows });
                }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            variant="contained"
            color="primary"
            onClick={(e) => {
              e.preventDefault();
              // alert(JSON.stringify(rowSelect.rows));
              handleAdd(rowSelect.rows);
              setRowSelect({
                // tableRef: createRef(),
                // selected: true,
                // selectedRowId: null,
                // c: "blue",
                // currentRow: {},
              });
              handleClose();
            }}
          >
            <SaveIcon />
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
